import React, { useContext } from 'react';
import { IconProps } from '../iconProps';
import { UiContext } from 'shared/lib/contexts/uiContext';
import cx from 'classnames';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';

export default function IconPng({
  isAutoscallable = true,
  sizeKey = '23x22',
  onClick,
  style,
}: IconProps) {
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      className={cx('icon', { 'icon-disabled': !onClick })}
      onClick={onClick}
      style={style}
      width={w}
      height={h}
      viewBox="0 0 23 22"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3685_63685)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.75 6.1875V19.25C19.75 19.9793 19.4603 20.6788 18.9445 21.1945C18.4288 21.7103 17.7293 22 17 22V20.625C17.3647 20.625 17.7144 20.4801 17.9723 20.2223C18.2301 19.9644 18.375 19.6147 18.375 19.25V6.1875H15.625C15.078 6.1875 14.5534 5.9702 14.1666 5.58341C13.7798 5.19661 13.5625 4.67201 13.5625 4.125V1.375H6C5.63533 1.375 5.28559 1.51987 5.02773 1.77773C4.76987 2.03559 4.625 2.38533 4.625 2.75V15.125H3.25V2.75C3.25 2.02065 3.53973 1.32118 4.05546 0.805456C4.57118 0.289731 5.27065 0 6 0L13.5625 0L19.75 6.1875ZM14.58 17.369C14.6845 17.5794 14.7491 17.8049 14.7725 18.0455H13.7055C13.6806 17.9247 13.6355 17.8089 13.5721 17.7031C13.5111 17.6023 13.4319 17.5137 13.3384 17.4419C13.2418 17.3638 13.1312 17.305 13.0125 17.2686C12.8795 17.2269 12.7408 17.2065 12.6014 17.2081C12.2095 17.2081 11.9056 17.3456 11.687 17.6234C11.4725 17.8997 11.3652 18.2889 11.3652 18.7921V19.4769C11.3652 19.7986 11.4093 20.0805 11.4986 20.3225C11.5786 20.5491 11.7241 20.7467 11.9166 20.8904C12.1272 21.0312 12.3771 21.1015 12.6302 21.0911C12.8473 21.0991 13.0631 21.0538 13.2586 20.9591C13.4156 20.8766 13.5455 20.7506 13.6326 20.5961C13.7151 20.4449 13.7578 20.2799 13.7578 20.097V19.7464H12.6275V18.9351H14.7945V20.0324C14.7945 20.2978 14.7505 20.5508 14.6611 20.7886C14.5731 21.0248 14.4358 21.2395 14.2582 21.4184C14.065 21.6092 13.8329 21.756 13.5776 21.8488C13.3067 21.9505 12.9864 22.0014 12.6193 22.0014C12.2656 22.0087 11.9139 21.9471 11.5839 21.8199C11.3033 21.7052 11.0526 21.5279 10.851 21.3015C10.6496 21.0697 10.4997 20.7979 10.411 20.504C10.3111 20.1719 10.2624 19.8264 10.2666 19.4796V18.7839C10.2666 18.2861 10.3588 17.8516 10.5416 17.4776C10.7259 17.105 10.9926 16.8149 11.3419 16.6073C11.6939 16.3983 12.1187 16.2938 12.6151 16.2938C12.9424 16.2938 13.2339 16.3391 13.4896 16.4312C13.7467 16.522 13.9681 16.6485 14.1496 16.8094C14.3325 16.9703 14.4769 17.1572 14.5814 17.369H14.58ZM2.7 16.3982H0.5V21.8982H1.58763V20.0516H2.69175C3.08637 20.0516 3.42188 19.9732 3.69825 19.8151C3.97738 19.6529 4.1905 19.4356 4.33488 19.162C4.48473 18.8749 4.56081 18.555 4.55625 18.2311C4.55625 17.8874 4.48338 17.578 4.339 17.3002C4.1954 17.0255 3.97584 16.7978 3.7065 16.6444C3.4315 16.4794 3.09738 16.3982 2.7 16.3982ZM3.44937 18.2311C3.45456 18.4128 3.41439 18.5928 3.3325 18.755C3.25901 18.8954 3.14498 19.0103 3.00525 19.085C2.84518 19.1642 2.66813 19.2029 2.48962 19.1978H1.5835V17.2645H2.491C2.79075 17.2645 3.02588 17.347 3.195 17.5147C3.36413 17.6798 3.44937 17.9204 3.44937 18.2311ZM6.14988 21.8969V18.2188H6.19387L8.61525 21.8969H9.51725V16.3982H8.486V20.0557H8.442L6.033 16.3982H5.12275V21.8982L6.14988 21.8969Z"
          fill="#333333"
        />
      </g>
      <defs>
        <clipPath id="clip0_3685_63685">
          <rect
            width="22"
            height="22"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
